import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ForgotService } from './forgot-service.service';
import * as moment from 'moment';

@Component({
  selector: 'app-forgot-password-boxed',
  templateUrl: './forgot-password.component.html',
  styles: []
})
export class ForgotPasswordBoxedComponent implements OnInit {

  forgetData: any = {
    email: '',
  };
  validateEmail: boolean = true;
  date: string;

  constructor(private forgotService: ForgotService,
              private router: Router,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.date = moment(new Date()).format('YYYY');
  }

  emailValidation (username) {
    let regex =/^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
 if (regex.test(username)) {
    this.validateEmail = false;
 }
 else
 {
     this.validateEmail = true;
 }
 }
  forget(data) {
    this.validateEmail = true;
    console.log('forget', data);
    this.forgotService.forgot(data)
      .then(() => {
        this.router.navigate(['/login']);
        this.toastr.success('We sent a password recovery link at your email, please check');
      }, error => {
        this.validateEmail = false;
        console.log('fail callback', error.status);
        if (error.status === 500) {
          this.toastr.error('Email does not exist!');
        }
             });
  }
}
